<template>
  <div class="chat-history" ref="chatHistory">
    <div v-for="(message, index) in messages" :key="index" class="message"
         :class="{ 'sent': message.sender.includes('teacher'), 'received': !message.sender.includes('teacher')}">
      {{ message.text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: Array,
    activeFriend: String
  }
};
</script>

<style scoped>
.chat-history {
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 10px;
}
.message {
  margin-bottom: 10px;
  max-width: 70%;
  word-wrap: break-word;
  padding: 10px;
  border-radius: 5px;
}
.sent {
  background-color: #e1ffc7;
  float: right;
  clear: both;
}
.received {
  background-color: #c6e2ff;
  float: left;
  clear: both;
}
</style>